"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageIcon = void 0;
const vue_1 = require("vue");
const constants_1 = require("../constants");
const LanguageSelectionDialog_1 = require("./LanguageSelectionDialog");
const PreferencesManager_1 = require("./PreferencesManager");
const TranslateMixin_1 = require("./TranslateMixin");
exports.LanguageIcon = vue_1.default.component('language-icon', {
    name: 'LanguageIcon',
    components: {
        'language-selection-dialog': LanguageSelectionDialog_1.LanguageSelectionDialog,
    },
    data() {
        return {
            languagePanelOpen: false,
        };
    },
    methods: {
        toggleLanguagePanelOpen: function () {
            this.languagePanelOpen = !this.languagePanelOpen;
        },
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    computed: {
        preferencesManager() {
            return PreferencesManager_1.PreferencesManager;
        },
        lang() {
            return (PreferencesManager_1.PreferencesManager.load('lang') || 'en');
        },
        title() {
            return constants_1.LANGUAGES2[this.lang];
        },
    },
    template: `
  <div class="preferences_item preferences_item--language" :title="$t('Language')">
    <div
      class="preferences_icon preferences_icon--language"
      :class="{'preferences_item--is-active': languagePanelOpen}">
      <div :class="'language-icon language-icon--for-sidebar language-icon--' + lang"
      :title="title"
      v-on:click="toggleLanguagePanelOpen"/>
      </div>
    <language-selection-dialog v-show="languagePanelOpen" :preferencesManager="preferencesManager"/>
  </div>
  `,
});
//# sourceMappingURL=LanguageIcon.js.map